import { useMemo } from 'react'

import { Nullable } from '@types'

import { getShortlistNextSortOrder } from '@modules/shortlist/constants'
import { ShortlistSortOrder } from '@modules/shortlist/types'
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined'

import { SortArrowBox } from './SortArrow.styles'

interface SortArrowProps {
  isActive: boolean
  order?: Nullable<ShortlistSortOrder>
  isHovered: boolean
  fieldName?: string
}

const fieldNameMap = {
  profileTitle: 'title',
  futureEvents: 'future_event',
  lastEvent: 'last_event',
  createdAt: 'date_added',
  contactStatus: 'contact_status',
  updatedAt: 'profile_updated',
  tagId: 'status',
}

const SortArrow = ({ isActive, order, isHovered, fieldName }: SortArrowProps) => {
  const arrowColor = isActive ? 'primary' : 'inherit'
  const nextSortOrder = getShortlistNextSortOrder(isActive, order, fieldName)

  const id = useMemo(() => {
    const field = fieldNameMap[fieldName as keyof typeof fieldNameMap] ?? fieldName
    if (!nextSortOrder) {
      return `shortlist-${field}-deselect_sort`
    }
    return `shortlist-${field}-${nextSortOrder.toLowerCase()}ending`
  }, [fieldName, nextSortOrder])

  return (
    <SortArrowBox $isActive={isActive} $isHovered={isHovered} id={id}>
      <ArrowUpwardOutlinedIcon
        sx={{
          transition: 'none',
          transform: isActive && order === ShortlistSortOrder.DESC ? 'rotate(180deg)' : 'none',
        }}
        color={arrowColor}
      />
    </SortArrowBox>
  )
}

export default SortArrow
